(function () {
  window.lumenearzHomeV2Loaded = (window.lumenearzHomeV2Loaded || 0) + 1;
  let initAttempts = 0;

  const getCartTarget = () => document.querySelector('cart-drawer') || document.querySelector('cart-notification');

  const getCartAddUrl = () => {
    const cartAddUrl = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add';

    return cartAddUrl.endsWith('.js') ? cartAddUrl : `${cartAddUrl}.js`;
  };

  const getCartUrl = () => (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart');

  const getCssLength = (name) => {
    const value = window.getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    const parsed = Number.parseFloat(value);

    if (!Number.isFinite(parsed)) return null;
    if (value.endsWith('rem')) {
      const rootFontSize = Number.parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 16;

      return parsed * rootFontSize;
    }

    return parsed;
  };

  const getVisibleViewportHeight = () =>
    getCssLength('--lx-viewport-height') ||
    (window.visualViewport && window.visualViewport.height) ||
    window.innerHeight ||
    document.documentElement.clientHeight;

  const getGroupElements = (root, selector, group) =>
    Array.from(root.querySelectorAll(selector)).filter((element) => element.dataset.bundleGroup === group);

  const updateBundleSubmit = (root, activeItem) => {
    const submit = root.querySelector('[data-home-v2-bundle-submit]');
    const submitText = root.querySelector('[data-home-v2-bundle-submit-text]');
    const selectedText = root.querySelector('[data-home-v2-bundle-selected]');
    const addLabel = root.dataset.addLabel || 'Add Bundle';
    const unavailableLabel = root.dataset.unavailableLabel || 'Unavailable';
    const soldOutLabel = root.dataset.soldOutLabel || 'Sold out';
    const baseAvailable = root.dataset.baseAvailable === 'true' && root.dataset.baseVariantId;
    const itemAvailable = activeItem && activeItem.dataset.productAvailable === 'true' && activeItem.dataset.variantId;
    const isAvailable = Boolean(baseAvailable && itemAvailable);

    if (submit) {
      submit.disabled = !isAvailable;
      submit.setAttribute('aria-disabled', String(!isAvailable));
    }

    if (submitText) {
      submitText.textContent = isAvailable ? addLabel : activeItem && activeItem.dataset.variantId ? soldOutLabel : unavailableLabel;
    }

    if (selectedText && activeItem) {
      selectedText.textContent = `Selected bundle item: ${activeItem.dataset.productTitle || 'Bundle item'}`;
    }
  };

  const selectBundleItem = (root, group, index) => {
    const targetIndex = String(index || '0');
    const mediaItems = Array.from(root.querySelectorAll('[data-home-v2-bundle-media]'));
    const selectors = Array.from(root.querySelectorAll('[data-home-v2-bundle-item]'));
    let activeItem = null;

    mediaItems.forEach((media) => {
      const isActive = media.dataset.bundleGroup === group && media.dataset.bundleIndex === targetIndex;

      media.hidden = !isActive;
      media.classList.toggle('is-active', isActive);
    });

    selectors.forEach((selector) => {
      if (selector.dataset.bundleGroup !== group) return;

      const isActive = selector.dataset.bundleIndex === targetIndex;

      selector.classList.toggle('is-active', isActive);
      selector.setAttribute('aria-pressed', String(isActive));
      selector.setAttribute('aria-checked', String(isActive));

      if (isActive) activeItem = selector;
    });

    updateBundleSubmit(root, activeItem);
  };

  const setBundleGroup = (root, group) => {
    const nextGroup = group === 'accessories' ? 'accessories' : 'shades';
    const panels = Array.from(root.querySelectorAll('[data-home-v2-bundle-selector-panel]'));
    const dots = Array.from(root.querySelectorAll('[data-home-v2-bundle-group]'));
    const subtitles = Array.from(root.querySelectorAll('[data-home-v2-bundle-subtitle]'));
    const activeSelector =
      getGroupElements(root, '[data-home-v2-bundle-item]', nextGroup).find((selector) =>
        selector.classList.contains('is-active')
      ) || getGroupElements(root, '[data-home-v2-bundle-item]', nextGroup)[0];

    root.dataset.activeGroup = nextGroup;

    panels.forEach((panel) => {
      const isActive = panel.dataset.bundleGroup === nextGroup;

      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);
    });

    dots.forEach((dot) => {
      const isActive = dot.dataset.bundleGroup === nextGroup;

      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-pressed', String(isActive));
    });

    subtitles.forEach((subtitle) => {
      subtitle.hidden = subtitle.dataset.bundleGroup !== nextGroup;
    });

    if (activeSelector) {
      selectBundleItem(root, nextGroup, activeSelector.dataset.bundleIndex);
    } else {
      updateBundleSubmit(root, null);
    }
  };

  const getBundleGroups = (root) => {
    const groups = Array.from(root.querySelectorAll('[data-home-v2-bundle-group]'))
      .map((button) => button.dataset.bundleGroup)
      .filter(Boolean);

    return groups.length ? groups : ['shades', 'accessories'];
  };

  const getBundleGroupDirection = (root, targetGroup) => {
    const groups = getBundleGroups(root);
    const activeGroup = root.dataset.activeGroup || groups[0];
    const activeIndex = groups.indexOf(activeGroup);
    const targetIndex = groups.indexOf(targetGroup);

    if (activeIndex === -1 || targetIndex === -1) return 'next';

    return targetIndex >= activeIndex ? 'next' : 'previous';
  };

  const getAdjacentBundleGroup = (root, direction) => {
    const groups = getBundleGroups(root);
    const activeGroup = root.dataset.activeGroup || groups[0];
    const activeIndex = Math.max(0, groups.indexOf(activeGroup));
    const nextIndex =
      direction === 'previous'
        ? (activeIndex - 1 + groups.length) % groups.length
        : (activeIndex + 1) % groups.length;

    return groups[nextIndex];
  };

  const updateBundleArrows = (root) => {
    const arrows = Array.from(root.querySelectorAll('[data-home-v2-bundle-arrow]'));
    const hasMultipleGroups = getBundleGroups(root).length > 1;

    arrows.forEach((arrow) => {
      arrow.hidden = !hasMultipleGroups;
      arrow.disabled = !hasMultipleGroups;
      arrow.setAttribute('aria-disabled', String(!hasMultipleGroups));
    });
  };

  const setBundleGroupWithMotion = (root, group, direction) => {
    const nextGroup = group === 'accessories' ? 'accessories' : 'shades';
    const currentGroup = root.dataset.activeGroup || 'shades';

    if (nextGroup === currentGroup) {
      setBundleGroup(root, nextGroup);
      return;
    }

    window.clearTimeout(root.homeV2BundleMotionTimer);
    root.dataset.slideDirection = direction === 'previous' ? 'previous' : 'next';
    root.classList.remove('is-sliding');
    void root.offsetWidth;
    root.classList.add('is-sliding');

    setBundleGroup(root, nextGroup);

    root.homeV2BundleMotionTimer = window.setTimeout(() => {
      root.classList.remove('is-sliding');
      delete root.dataset.slideDirection;
    }, 280);
  };

  const bindBundleSwipe = (root) => {
    const swipeTarget = root.querySelector('.lx-home-v2-bundle__offer');

    if (!swipeTarget) return;

    let pointerId = null;
    let startX = 0;
    let startY = 0;

    const clearSwipe = () => {
      pointerId = null;
      startX = 0;
      startY = 0;
    };

    swipeTarget.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      pointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
    });

    swipeTarget.addEventListener('pointerup', (event) => {
      if (pointerId !== event.pointerId) {
        clearSwipe();
        return;
      }

      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;
      const isSwipe = Math.abs(deltaX) > 48 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2;

      if (isSwipe) {
        const direction = deltaX < 0 ? 'next' : 'previous';

        root.dataset.homeV2BundleSuppressClick = 'true';
        setBundleGroupWithMotion(root, getAdjacentBundleGroup(root, direction), direction);
      }

      clearSwipe();
    });

    swipeTarget.addEventListener('pointercancel', clearSwipe);
    swipeTarget.addEventListener('pointerleave', (event) => {
      if (event.pointerType === 'mouse') clearSwipe();
    });
  };

  const handleBundleAdd = (root) => {
    const submit = root.querySelector('[data-home-v2-bundle-submit]');
    const message = root.querySelector('[data-home-v2-bundle-message]');
    const activeGroup = root.dataset.activeGroup || 'shades';
    const activeItem = getGroupElements(root, '[data-home-v2-bundle-item]', activeGroup).find((item) =>
      item.classList.contains('is-active')
    );
    const baseVariantId = Number.parseInt(root.dataset.baseVariantId, 10);
    const partnerVariantId = activeItem ? Number.parseInt(activeItem.dataset.variantId, 10) : Number.NaN;
    const cart = getCartTarget();

    if (!submit || submit.disabled || submit.classList.contains('is-loading')) return;

    if (!baseVariantId || !partnerVariantId) {
      if (message) {
        message.textContent = root.dataset.unavailableLabel || 'Unavailable';
        message.hidden = false;
      }
      updateBundleSubmit(root, activeItem);
      return;
    }

    if (message) {
      message.hidden = true;
      message.textContent = '';
    }

    submit.classList.add('is-loading');
    submit.disabled = true;
    submit.setAttribute('aria-disabled', 'true');

    const payload = {
      items: [
        { id: baseVariantId, quantity: 1 },
        { id: partnerVariantId, quantity: 1 },
      ],
    };

    if (cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart.getSectionsToRender().map((section) => section.id);
      payload.sections_url = window.location.pathname;

      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }
    }

    const config = window.fetchConfig
      ? window.fetchConfig('javascript')
      : {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        };

    config.headers = config.headers || {};
    config.headers['Content-Type'] = 'application/json';
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify(payload);

    fetch(getCartAddUrl(), config)
      .then((response) =>
        response.json().then((parsedState) => {
          if (!response.ok || parsedState.status) throw parsedState;
          return parsedState;
        })
      )
      .then((parsedState) => {
        const firstItem = parsedState.items && parsedState.items[0] ? parsedState.items[0] : null;

        if (firstItem) {
          parsedState.key = firstItem.key;
          parsedState.id = firstItem.id;
        }

        if (window.publish && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'lumenearz-home-v2-bundle',
            productVariantId: partnerVariantId,
            cartData: parsedState,
          });
        }

        if (cart && typeof cart.renderContents === 'function' && parsedState.sections) {
          if (
            cart.tagName &&
            cart.tagName.toLowerCase() === 'cart-notification' &&
            cart.header &&
            typeof cart.header.reveal !== 'function'
          ) {
            cart.header = null;
          }

          cart.renderContents(parsedState);
          if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        } else {
          window.location = getCartUrl();
        }
      })
      .catch((error) => {
        if (message) {
          message.textContent = error.description || error.message || 'Unable to add this bundle right now.';
          message.hidden = false;
        }
      })
      .finally(() => {
        submit.classList.remove('is-loading');
        updateBundleSubmit(root, activeItem);
      });
  };

  const initBundles = () => {
    const bundleRoots = Array.from(document.querySelectorAll('[data-home-v2-bundle]'));

    bundleRoots.forEach((root) => {
      if (root.dataset.homeV2BundleBound === 'true') return;

      root.dataset.homeV2BundleBound = 'true';

      root.addEventListener('click', (event) => {
        if (root.dataset.homeV2BundleSuppressClick === 'true') {
          event.preventDefault();
          event.stopPropagation();
          delete root.dataset.homeV2BundleSuppressClick;
          return;
        }

        const groupButton = event.target.closest('[data-home-v2-bundle-group]');
        const arrowButton = event.target.closest('[data-home-v2-bundle-arrow]');
        const itemButton = event.target.closest('[data-home-v2-bundle-item]');
        const submitButton = event.target.closest('[data-home-v2-bundle-submit]');

        if (arrowButton && root.contains(arrowButton)) {
          const direction = arrowButton.dataset.bundleDirection === 'previous' ? 'previous' : 'next';

          setBundleGroupWithMotion(root, getAdjacentBundleGroup(root, direction), direction);
          return;
        }

        if (groupButton && root.contains(groupButton)) {
          setBundleGroupWithMotion(root, groupButton.dataset.bundleGroup, getBundleGroupDirection(root, groupButton.dataset.bundleGroup));
          return;
        }

        if (itemButton && root.contains(itemButton)) {
          setBundleGroupWithMotion(root, itemButton.dataset.bundleGroup, getBundleGroupDirection(root, itemButton.dataset.bundleGroup));
          selectBundleItem(root, itemButton.dataset.bundleGroup, itemButton.dataset.bundleIndex);
          return;
        }

        if (submitButton && root.contains(submitButton)) {
          handleBundleAdd(root);
        }
      });

      bindBundleSwipe(root);
      updateBundleArrows(root);
      setBundleGroup(root, root.dataset.activeGroup || 'shades');
    });

    return bundleRoots.length;
  };

  const initHomeV2 = () => {
    const bundleCount = initBundles();
    const storyRoots = Array.from(document.querySelectorAll('[data-home-v2-scroll-story]'));

    if (!storyRoots.length) {
      if (!bundleCount && initAttempts < 20) {
        initAttempts += 1;
        window.setTimeout(initHomeV2, 100);
      }

      return;
    }

    let pendingRoots = false;
    let boundRoots = 0;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    storyRoots.forEach((root) => {
      if (root.dataset.homeV2ScrollStoryBound === 'true') {
        boundRoots += 1;
        return;
      }

      const component = root.querySelector('[data-home-v2-scroll-story-component]');
      const features = Array.from(root.querySelectorAll('[data-home-v2-scroll-feature]'));
      const tabs = Array.from(root.querySelectorAll('[data-home-v2-scroll-tab]'));
      const triggers = Array.from(root.querySelectorAll('[data-home-v2-scroll-trigger]'));
      const video = root.querySelector('[data-home-v2-scroll-story-video]');

      if (!component || !features.length || !tabs.length || !triggers.length) {
        pendingRoots = true;
        return;
      }

      root.dataset.homeV2ScrollStoryBound = 'true';
      boundRoots += 1;

      let activeIndex = 0;
      let highestRevealedIndex = 0;
      let tabLockUntil = 0;
      let scrollFrame = null;

      const setActive = (index) => {
        const nextIndex = Math.max(0, Math.min(features.length - 1, Number.parseInt(index, 10) || 0));

        activeIndex = nextIndex;
        highestRevealedIndex = Math.max(highestRevealedIndex, nextIndex);
        component.dataset.activeIndex = String(nextIndex);
        root.dataset.activeIndex = String(nextIndex);

        features.forEach((feature, featureIndex) => {
          const isActive = featureIndex === nextIndex;
          const isRevealed = featureIndex <= highestRevealedIndex;

          feature.classList.toggle('is-active', isActive);
          feature.classList.toggle('is-revealed', isRevealed);
          feature.setAttribute('aria-current', isActive ? 'step' : 'false');
          feature.setAttribute('aria-hidden', String(!isRevealed));
        });

        tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === nextIndex;

          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-pressed', String(isActive));
        });
      };

      const getIndexFromTriggers = () => {
        const centerY = getVisibleViewportHeight() / 2;
        let nextIndex = activeIndex;
        let closestDistance = Number.POSITIVE_INFINITY;

        triggers.forEach((trigger, triggerIndex) => {
          const rect = trigger.getBoundingClientRect();

          if (rect.top <= centerY && rect.bottom >= centerY) {
            nextIndex = triggerIndex;
            closestDistance = 0;
            return;
          }

          const distance = Math.abs(rect.top - centerY);

          if (rect.top <= centerY && distance < closestDistance) {
            closestDistance = distance;
            nextIndex = triggerIndex;
          }
        });

        return nextIndex;
      };

      const updateFromTriggers = () => {
        if (Date.now() < tabLockUntil) return;

        const nextIndex = getIndexFromTriggers();

        if (nextIndex !== activeIndex) setActive(nextIndex);
      };

      const queueTriggerUpdate = () => {
        if (scrollFrame) return;

        scrollFrame = window.requestAnimationFrame(() => {
          scrollFrame = null;
          updateFromTriggers();
        });
      };

      const activateFromTab = (tab) => {
        const nextIndex = Number.parseInt(tab.dataset.featureIndex, 10) || 0;
        const trigger = triggers[nextIndex];

        tabLockUntil = Date.now() + 650;
        setActive(nextIndex);

        if (trigger) {
          trigger.scrollIntoView({
            block: 'center',
            behavior: prefersReducedMotion ? 'auto' : 'smooth',
          });
        }
      };

      root.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-home-v2-scroll-tab]');

        if (!tab || !root.contains(tab)) return;

        activateFromTab(tab);
      });

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            if (Date.now() < tabLockUntil || !entries.some((entry) => entry.isIntersecting)) return;

            updateFromTriggers();
          },
          {
            root: null,
            rootMargin: '-40% 0px -40% 0px',
            threshold: [0, 0.01, 0.5, 1],
          }
        );

        triggers.forEach((trigger) => observer.observe(trigger));
      } else {
        features.forEach((feature) => feature.classList.add('is-revealed'));
      }

      window.addEventListener('scroll', queueTriggerUpdate, { passive: true });
      window.addEventListener('resize', queueTriggerUpdate);
      window.addEventListener('pageshow', queueTriggerUpdate);
      window.addEventListener('lumenearz:viewportchange', queueTriggerUpdate);

      if (video && video.paused && !prefersReducedMotion) {
        video.play().catch(() => {});
      }

      const initialHashTarget = window.location.hash ? document.getElementById(window.location.hash.slice(1)) : null;
      const initialHashIndex =
        initialHashTarget && root.contains(initialHashTarget)
          ? Number.parseInt(initialHashTarget.dataset.featureIndex, 10)
          : 0;

      if (initialHashTarget && !Number.isNaN(initialHashIndex)) {
        tabLockUntil = Date.now() + 650;
        setActive(initialHashIndex);
      } else {
        setActive(0);
        queueTriggerUpdate();
      }
    });

    window.lumenearzHomeV2Initialized = boundRoots;
    window.lumenearzHomeV2BundleInitialized = bundleCount;

    if (pendingRoots && initAttempts < 20) {
      initAttempts += 1;
      window.setTimeout(initHomeV2, 100);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHomeV2, { once: true });
  } else {
    initHomeV2();
  }

  document.addEventListener('shopify:section:load', initHomeV2);
})();
